import { createContext } from 'react'

export type AuthState = {
  isAuthenticated: boolean
  twoFA: {
    required: boolean
    type: string | null
  }
  idUser: string | null
}

export const AuthContext = createContext<AuthState | null>(null)
export const AuthDispatchContext = createContext<{
  saveRememberMeToken: (token: string) => void
  decodeTwoFAToken: (token: string) => void
  login: (token: string) => void
  logout: () => void
} | null>(null)
